<script setup>
import {reactive,onMounted} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  loading: false,
  dataLoading: true,
  search: null,
  newClient: false,
  headers: [
    { title: 'Name', key: 'name' },
    { title: 'Actions', key: 'actions' },
  ],
  items: [],
  names: [],
  newId: null,
});

const getData = () => {
  ApiWrapper.post('reviewers', 'get-clients', {
        personId: props.contextIdA
      })
      .then((response) => {
        if(response.items){
          data.items = response.items
        }
        if(response.names){
          data.names = response.names
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })
}

const addClient = () => {
  data.loading = true
  ApiWrapper.post('reviewers', 'new-client', {
        personId: props.contextIdA,
        id: data.newId,
      })
      .then((response) => {
        getData()
        data.newClient = false
        data.newId = null
        data.loading = false
        ToastUtil.successMsg('Assigned new reviewer');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false
      })
}

const removeClient = (item) => {
  data.loading = true
  ApiWrapper.post('reviewers', 'remove-client', {
        personId: props.contextIdA,
        id: item.id,
      })
      .then((response) => {
        getData()
        data.loading = false
        ToastUtil.successMsg('Removed reviewer');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Reviewer For Clients</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>

        <v-btn size="small" v-if="!data.newClient && Permissions.checkPermissions(['reviewers.new-client'])" class="primary"  @click="data.newClient = true">
          Add client for review
        </v-btn>
        <!-- <v-autocomplete
          v-model="newId"
          :items="names"
          :rules="[v => !!v || 'A client is required']"
          label="Type or Select Client's Name"
          clearable
          class="mx-4 mt-5"
          v-if="newClient"
        ></v-autocomplete>
        <div v-if="newClient">
          <v-btn  size="x-small" class="ml-2 mr-2" @click="addClient()" color="primary">
            <v-icon color="white">mdi-plus</v-icon>
          </v-btn>
          <v-btn
            size="x-small"
            @click="newId=null; newClient=false"
            color="error"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div> -->


      </v-toolbar>
      <v-row v-if="data.newClient" align="center">
        <v-col
            cols="6"
        >
          <v-autocomplete
              v-model="data.newId"
              :items="data.names"
              :rules="[v => !!v || 'A client is required']"
              label="Type or Select Client's Name"
              clearable
              class="mx-4"
              item-title="text"
          ></v-autocomplete>
        </v-col>
        <v-col
            cols="6"
        >
          <v-btn size="small" variant="elevated" class="px-2" @click="addClient()" color="primary">
            <v-icon color="white">mdi-plus</v-icon>
          </v-btn>
          <v-btn
              size="small"
              variant="elevated"
              class="px-2"
              @click="data.newId=null; data.newClient=false"
              color="error"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col
            cols="12"
            sm="6"
            md="4"
        >
          <v-text-field
              v-model="data.search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="mx-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-if="Permissions.checkPermissions(['reviewers.remove-client'])" @click="removeClient(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>